module.exports = __webpack_public_path__ + "static/media/pacientes-icon.e37ebfd7.svg";